import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Button } from '@material-ui/core';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const CancelPopUpModel = (props) => {
  const { cancelPopUp, onYes, onNo } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const handleClose = () => {
    onNo();
  };

  const onDeleteClick = () => {
    onYes();
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='ird-modal-body'>
        <div className='ird-menu-title ird-menu-title-cancel'>{cancelPopUp.title}</div>
        <p className='ird-menu-modal-description'>{cancelPopUp.description}</p>
        <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
          <Button
            variant='outlined'
            size='large'
            color='secondary'
            className='ird-menu-no-btn'
            onClick={(e) => handleClose()}
          >
            No
          </Button>
          <Button
            variant='contained'
            size='large'
            color='primary'
            className='ird-menu-yes-btn'
            onClick={(e) => onDeleteClick()}
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={cancelPopUp.status} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default CancelPopUpModel;
